import { render, staticRenderFns } from "./APIVersion.vue?vue&type=template&id=226da74f&"
import script from "./APIVersion.vue?vue&type=script&lang=js&"
export * from "./APIVersion.vue?vue&type=script&lang=js&"
import style0 from "./APIVersion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports